
<div class="mainContainer">
  <div class="logoContainer">
    <div class="ImageContainer" [ngClass]="{
          'default-logo': this.ImageURL == null || this.ImageURL.trim() == ''
        }">
      <img *ngIf="!(this.ImageURL == null || this.ImageURL.trim() == '')" [src]="ImageURL" alt="Logo"
        class="inner-image" />
    </div>
    <div class="divider"></div>
    <div class="snapshot-study-name-area">
      <div class="snapshot-study-header-name" (click)="showSnapshotDropdown()" DocumentClick (DocumentClicked)="this.showSnapshotDropdownVal=false">
        
        <div class="snapshot-label">{{this._configService.capitalizeWords(snapNameNavHeader)}}</div>
        <div class="brand-block-wrapper">
          <span class="brand-block">{{this._configService.selectedSubSection !== "" && this._configService.selectedSubSection !== "NA"  ? this._configService.capitalizeWords(this._configService.selectedSubSection) : this._configService.capitalizeWords(this._configService.selectedSection) }}</span>
          <span class="study-open-icon"></span>
        </div>
      </div>      
      <div class="SnapshotListArea" *ngIf="showSnapshotDropdownVal" id="snapshot-dropdown">
        <div class="Dropdown-popup-Across" *ngIf="AcrossDropdown.length>0">
          <div class="Dropdown-popup-Across-scroll">
            <div class="Across-container" *ngFor="let item of AcrossDropdown">
                 <div title="{{item.snapshotType_name}}" class="Across-container-snapshotType-txt">
                      <span title="{{item.snapshotType_name}}"> {{item.snapshotType_name}}</span>
                 </div>
                 <div class="Across-container-section-block" *ngFor="let section of item.section">
                    <div class="Across-section-container" *ngIf="section.subsection[0].subsection_name=='NA'" title="{{section.section_name}}"
                    [ngClass]="{ 'active': this._configService.selectedSection !== '' && section.section_name === this._configService.selectedSection && this._configService.snapshotTypeSelectedName == item.snapshotType_name}" (click)="navigateSnapshot(item, section, '')">
                        <span title="{{section.section_name}}"> {{section.section_name}}</span> 
                    </div>
                    <div class="Across-subsection-container-block" *ngIf="section.subsection[0].subsection_name!='NA'">
                        <div class="Across-section-container2"  title="{{section.section_name}}">
                            <span title="{{section.section_name}}"> {{section.section_name}}</span> 
                        </div>
                        <div class="Across-subsection-container" 
                         title="{{section.section_name}}" *ngFor="let subsection of section.subsection"
                         [ngClass]="{ 'active': this._configService.selectedSubSection !== '' && subsection.subsection_name === this._configService.selectedSubSection && this._configService.selectedSection === section.section_name && this._configService.snapshotTypeSelectedName === item.snapshotType_name}">
                            <span title="{{subsection.subsection_name}}" (click)="navigateSnapshot(item, section,  subsection)"> - {{subsection.subsection_name}}</span> 
                        </div>
                    </div>
                </div>
            </div>
         </div>
        </div>
        
        <!-- <div class="snapshotDropdown" *ngFor="let snap of snapshotListData[0].UniqueSnapshots != undefined ? snapshotListData[0].UniqueSnapshots : snapshotListData[0].UniqueStudies">
          <div class="snapshotDropdown_Container" (click)="navigateSnapshot(snap)">
            <div class="snapshotDropdown_Container_Name" [class.selected_Text]="snap === selected_Snap">{{ snap }}</div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>